import React, { useContext } from "react";
import { Button, Card, Form, Input, Typography, message, Carousel } from "antd";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../services/authcontext";
import AuthService from "../services/authservice";
import usePageTitle from "../services/usePageTitle";

function Login() {
  usePageTitle("Login - SkeyeGate™");
  const { setIsAuthenticated, setUser } = useContext(AuthContext);
  const navigate = useNavigate();
  const [messageApi, contextHolder] = message.useMessage();

  const handleLogin = async (values) => {
    const response = await AuthService.login(values);
    if (response.isAuthenticated) {
      setIsAuthenticated(true);
      setUser(response.user);
      const userRole = response.user?.roles?.[0]?.name;
      navigate(userRole === "ROLE_ADMIN" ? "/Users" : "/");
    } else {
      messageApi.error(response.error || "Login failed");
    }
  };

  return (
    <div className="login-page">
      {contextHolder}

      <div className="login-side-panel">
        <div className="animated-bg-shapes">
          <div className="shape shape-1"></div>
          <div className="shape shape-2"></div>
        </div>

        <div className="login-brand-block">
          <div className="brand-mark login-brand-mark">
            <img src="/img/Gate.svg" alt="Skeyegate" />
          </div>

          <Carousel autoplay autoplaySpeed={3000} effect="fade" dots={false}>
            <div>
              <Typography.Title level={2} className="text-white">
                Welcome to Skeyegate
              </Typography.Title>
              <Typography.Paragraph className="carousel-text">
                Sign in to access your dashboard and manage your data ecosystem
                efficiently.
              </Typography.Paragraph>
            </div>
            <div>
              <Typography.Title level={2} className="text-white">
                Seamless Integration
              </Typography.Title>
              <Typography.Paragraph className="carousel-text">
                Connect and control your pipelines, modules, and datasets in one
                comprehensive platform.
              </Typography.Paragraph>
            </div>
            <div>
              <Typography.Title level={2} className="text-white">
                Secure & Fast
              </Typography.Title>
              <Typography.Paragraph className="carousel-text">
                Explore the powerful features with enterprise-grade security and
                performance.
              </Typography.Paragraph>
            </div>
          </Carousel>
        </div>
      </div>

      <div className="login-form-panel">
        <Card className="login-card" bordered={false} hoverable>
          <Typography.Title level={3} className="login-title">
            Sign In
          </Typography.Title>
          <Typography.Text className="login-subtitle">
            Enter your credentials to access your workspace.
          </Typography.Text>

          <Form
            layout="vertical"
            onFinish={handleLogin}
            className="login-form"
            requiredMark={false}
          >
            <Form.Item
              label="Username"
              name="username"
              rules={[
                { required: true, message: "Please enter your username" },
              ]}
            >
              <Input size="large" placeholder="Username" />
            </Form.Item>

            <Form.Item
              label="Password"
              name="password"
              rules={[
                { required: true, message: "Please enter your password" },
              ]}
            >
              <Input.Password size="large" placeholder="Password" />
            </Form.Item>

            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                size="large"
                className="login-btn"
                block
              >
                Sign In
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </div>
    </div>
  );
}

export default Login;
